import * as yup from 'yup';
import { NameFormValuesType } from './types';
import { validationSchemaName } from '../formValidations';

export const unknownWaitTimeText =
  "Hi there, we'll connect you with an Advocate as soon as we can. First, let's start with your name.";
export const shortWaitTimeText =
  'Hi there, the next customer Advocate will be available shortly. First, let’s start with your name.';
export const longWaitTimeText =
  "Hi there, our current wait time is pretty long, we're sorry for the inconvenience. We'll connect you with an Advocate as soon as we can, first, let's start with your name.";

export const waitTimeText = (waitTimeRound: number) =>
  `Hi there, the next customer Advocate will be available in ${waitTimeRound} minutes to help you. First, let’s start with your name.`;

export const validationSchema = yup.object().shape({
  name: validationSchemaName,
});

export const nameFormInitialValues: NameFormValuesType = {
  name: '',
};
